module.exports = __webpack_public_path__ + "img/22Inch_Coin B.5fc1a65b.png";